import { TOUR_TRANSLATIONS } from "../translations"

export const getLbbOverviewSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="lbb-overview-filters"]',
            title: t.lbbOverviewFilters.title,
            content: t.lbbOverviewFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="lbb-overview-buybox-share"]',
            title: t.lbbOverviewBuyboxShare.title,
            content: t.lbbOverviewBuyboxShare.content,
        },
        {
            target: '[data-tour="lbb-overview-reason-share"]',
            title: t.lbbOverviewReasonShare.title,
            content: t.lbbOverviewReasonShare.content,
        },
        {
            target: '[data-tour="lbb-overview-competitors"]',
            title: t.lbbOverviewCompetitors.title,
            content: t.lbbOverviewCompetitors.content,
        },
        {
            target: '[data-tour="lbb-overview-table"]',
            title: t.lbbOverviewTable.title,
            content: t.lbbOverviewTable.content,
        },
    ]
}
